import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import useAuth from "@/hooks/useAuth";
import extrasApi from "@/api/extrasApi";
import ExtraForm from "@/components/ExtraForm/ExtraForm";
import ExtraRequest from "@/model/ExtraRequest";

function CreateExtraPage() {
  const { t } = useTranslation();
  const { session } = useAuth();
  const navigate = useNavigate();

  if (!session) {
    return null;
  }

  const handleSubmit = async (request: ExtraRequest) => {
    await extrasApi.createExtra(session.accessToken, request);
    navigate("/extras", { replace: true });
  };

  return (
    <ExtraForm
      title={t("extras.create.title")}
      submitLabel={t("extras.create.submit")}
      onSubmit={handleSubmit}
    />
  );
}

export default CreateExtraPage;
